import { MortgageFormData } from "../types/mortgage";

export function useCalculationInputs(formData: MortgageFormData, effectiveHouseholdExpenditure: number) {
  const mainCalculationInputs = {
    propertyValue: formData.property.propertyValue,
    loanRequired: formData.property.loanRequired,
    loanTermMonths: formData.property.loanTermMonths,
    payRate: formData.property.payRate,
    fiveYearFixedTerm: formData.property.fiveYearFixedTerm,
    repaymentType: formData.property.repaymentType,
    amountInterestOnly: formData.property.amountInterestOnly,
    loanType: formData.property.loanType,
    adults: formData.household.adults,
    children: formData.household.children,
    totalIncomeNetOfTax: formData.income.totalIncomeNetOfTax,
    foreignIncome: formData.income.foreignIncome,
    foreignCurrency: formData.income.foreignCurrency,
    incomeFromProperties: formData.income.incomeFromProperties,
    householdOnsOverride: formData.expenditure.householdOnsOverride,
    creditCommitments: formData.expenditure.commitments.creditCommitments,
    additionalCommitments: formData.expenditure.commitments.additionalCommitments,
    pensionContributions: formData.expenditure.commitments.pensionContributions,
    otherMortgages: formData.expenditure.commitments.otherMortgages,
    btlTotalValueOfBorrowing: formData.background.btlTotalValueOfBorrowing,
    otherTotalValueOfBorrowing: formData.background.otherTotalValueOfBorrowing,
    name: formData.contact.name,
    email: formData.contact.email,
    telephone: formData.contact.telephone,
    effectiveHouseholdExpenditure: effectiveHouseholdExpenditure,
  };

  const totalCostsInputs = {
    adults: formData.household.adults,
    children: formData.household.children,
    householdOnsOverride: formData.expenditure.householdOnsOverride,
    creditCommitments: formData.expenditure.commitments.creditCommitments,
    additionalCommitments: formData.expenditure.commitments.additionalCommitments,
    pensionContributions: formData.expenditure.commitments.pensionContributions,
    otherMortgages: formData.expenditure.commitments.otherMortgages,
    btlTotalValueOfBorrowing: formData.background.btlTotalValueOfBorrowing,
    otherTotalValueOfBorrowing: formData.background.otherTotalValueOfBorrowing,
    effectiveHouseholdExpenditure: effectiveHouseholdExpenditure,
  };

  return {
    mainCalculationInputs,
    totalCostsInputs,
  };
}
